const initialState = {
  data: []
}

const RentalsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_LOCS': {
      return {...state,
        data: action.data
      }    
    }

    case 'DELETE_INVOICE':
      return { ...state }
    default:
      return { ...state }
  }
}

export default RentalsReducer